import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServiceRoutingModule } from './service-routing.module';
import { AndroidAppDevelopmentComponent } from './Appsolution/android-app-development/android-app-development.component';
import { HybridAppDevelopmentComponent } from './Appsolution/hybrid-app-development/hybrid-app-development.component';
import { IosAppDevelopmentComponent } from './Appsolution/ios-app-development/ios-app-development.component';
import { NativeAppDevelopmentComponent } from './Appsolution/native-app-development/native-app-development.component';
import { DataentryComponent } from './websolution/dataentry/dataentry.component';
import { EcommercesolutionComponent } from './websolution/ecommercesolution/ecommercesolution.component';
import { SoftwareDevelopmentComponent } from './websolution/software-development/software-development.component';
import { WebApplicationDevelopmentComponent } from './websolution/web-application-development/web-application-development.component';
import { WebHostingSolutionsComponent } from './websolution/web-hosting-solutions/web-hosting-solutions.component';
import { WebsiteDesigningComponent } from './websolution/website-designing/website-designing.component';
import { BulkSmsAndEmailMarketingComponent } from './digitalmarketing/bulk-sms-and-email-marketing/bulk-sms-and-email-marketing.component';
import { DigitalMediaMarketingComponent } from './digitalmarketing/digital-media-marketing/digital-media-marketing.component';
import { SearchEngineOptimizationComponent } from './digitalmarketing/search-engine-optimization/search-engine-optimization.component';
import { SocialMediaPromotionComponent } from './digitalmarketing/social-media-promotion/social-media-promotion.component';
import { BulkSmsComponent } from './moreservices/bulk-sms/bulk-sms.component';
import { DigitalVisitingCardComponent } from './moreservices/digital-visiting-card/digital-visiting-card.component';
import { GraphicDesignComponent } from './moreservices/graphic-design/graphic-design.component';
import { LogoDesignComponent } from './moreservices/logo-design/logo-design.component';
import { VideoCreationComponent } from './moreservices/video-creation/video-creation.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    WebsiteDesigningComponent,
    SoftwareDevelopmentComponent,
    WebApplicationDevelopmentComponent,
    WebHostingSolutionsComponent,
    AndroidAppDevelopmentComponent,
    IosAppDevelopmentComponent,
    HybridAppDevelopmentComponent,
    NativeAppDevelopmentComponent,
    WebApplicationDevelopmentComponent,
    EcommercesolutionComponent,
    DataentryComponent,
    BulkSmsAndEmailMarketingComponent,
    SearchEngineOptimizationComponent,
    DigitalMediaMarketingComponent,
    SocialMediaPromotionComponent,
    BulkSmsComponent,
    DigitalVisitingCardComponent,
    GraphicDesignComponent,
    LogoDesignComponent,
    VideoCreationComponent,
  ],
  imports: [CommonModule, SharedModule, ServiceRoutingModule],
})
export class ServiceModule {}
